<template>
  <div class="hello">
      <h3>Thanks for answering the question</h3>
         <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
            {{results.msg}}<p></p>
              <b-button block squared @click="goToQuiz()" size="lg" :variant="results.outline" >Continue Quiz</b-button><p></p>
          </div>
         <div class="col-sm-4"></div>
         </div>
  </div>
</template>

<script>
export default {
  name: 'FinishedQuiz',
  props: {
    results: Object,
    // staticTitle: String
  },
    data () {
        return {
        }
    },
    methods: {
        goToQuiz: function () {
            console.log('try to continue quize')
            this.$emit('continueQuiz', this.results.quiz)
        }
    },
    created () {
        // this.getTitle()
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
